import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="lp-footer">
            <div className="lp-footer-inner">
                <div className="lp-footer-copy">
                    © {year} Finlytics. All rights reserved.
                    <span>v0.1.0</span>
                </div>
                <div className="lp-footer-links">
                    <button className="lp-footer-link" type="button">Terms</button>
                    <button className="lp-footer-link" type="button">Privacy</button>
                    <button className="lp-footer-link" type="button">Contact</button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
